import Gettext from "gettext.js";
import sk from "./locales/sk.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import cz from "./locales/cz.json";
import pt from "./locales/pt.json";
import fr from "./locales/fr.json";
import ar from "./locales/ar.json";
import es from "./locales/es.json";

const i18n = new Gettext({
  domain: "messages",
  locale: ['en', 'sk','cz', 'de', 'es', 'pt', 'fr', 'ar'].includes(window.acc_country) ? window.acc_country : 'en' // default Slovak
});

i18n.setMessages("messages", "sk", sk, "nplurals=1; plural=0;");
i18n.setMessages("messages", "en", en, "nplurals=1; plural=0;");
i18n.setMessages("messages", "de", de, "nplurals=1; plural=0;");
i18n.setMessages("messages", "es", es, "nplurals=1; plural=0;");
i18n.setMessages("messages", "cz", cz, "nplurals=1; plural=0;");
i18n.setMessages("messages", "pt", pt, "nplurals=1; plural=0;");
i18n.setMessages("messages", "fr", fr, "nplurals=1; plural=0;");
i18n.setMessages("messages", "ar", ar, "nplurals=1; plural=0;");

// expose helpers globally
window.gettext = (msgid) => i18n.gettext(msgid);
window.svgettext = (msgid) => i18n.gettext(msgid);

export default i18n;
